<script>
import { IconAlertTriangleFilled } from "@tabler/icons-vue";

export default {
	name: "Alert",
	components: {IconAlertTriangleFilled}
}
</script>

<template>
	<div
			class="sticky top-0 z-20 border-l-4 border-yellow-400 bg-yellow-50 -mx-8 -mt-6 mb-6 p-4 px-6 border-b border-b-slate-200">
		<div class="flex">
			<div class="flex-shrink-0">
				<IconAlertTriangleFilled class="h-5 w-5 text-yellow-400" aria-hidden="true"/>
			</div>
			<div class="ml-3">
				<h3 class="text-sm font-medium text-yellow-700">
					<slot></slot>
				</h3>

				<div v-if="!!$slots.list" class="mt-2 text-sm text-yellow-700">
					<ul role="list" class="list-disc space-y-1 pl-5">
						<slot name="list"></slot>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>

</style>